import axios from 'axios';
import {useCountryStore} from "../store/CountryStore";

export const useHttp = () => {
    axios.defaults.baseURL = useCountryStore().country.apiUrl;

    return axios;
}